import PackageRequest from './PackageRequest.vue';

export { PackageRequest };


// WEBPACK FOOTER //
// ./src/modules/home/packageRequest/index.js